import { useTranslation } from 'react-i18next';
import Select from 'react-select';

/**
 * Selector de "provider source" (tgx / viooh) con el mismo look&feel que AudienceProvider.
 *
 * Props:
 *  - value: string[]
 *  - onChange: (newValue: string[]) => void
 *  - disabled?: boolean
 */
export default function ProviderSourceSelect({ value, onChange, disabled = false }) {
  const { t } = useTranslation();

  const options = [
    { label: 'Taggify', value: 'tgx' },
    { label: 'Viooh', value: 'VIOOH' },
    { label: 'Outcon', value: 'outcon' },
  ];
  const selectedValues = Array.isArray(value)
    ? value
    : value
    ? [value]
    : [];
  const normalizedValues = selectedValues
    .map((selectedValue) => String(selectedValue ?? ''))
    .filter(Boolean);
  const selected = options.filter((option) =>
    normalizedValues.includes(String(option.value))
  );

  return (
    <div
      className="rounded m-1 mb-4"
      data-testid="provider-source-filter-container">
      <div className="header flex justify-between content-center">
        <div className="title text-xl font-extralight hidden">
          {t('sections.campaigns.new-campaign.wizard-screens.filters.provider-source-title', 'Source')}
        </div>
        <div
          className="brief w-full"
          data-testid="provider-source-select">
          <Select
            isDisabled={disabled}
            isMulti
            options={options}
            value={selected}
            onChange={(opt) =>
              onChange?.(Array.isArray(opt) ? opt.map((o) => o.value) : [])
            }
            placeholder={t(
              'sections.campaigns.new-campaign.wizard-screens.filters.provider-source-placeholder',
              'Select source'
            )}
          />
        </div>
      </div>
    </div>
  );
}
